import styled from 'astroturf/react'
import { Button } from '@calendly/ui/components/button'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import { useMedia } from '@calendly/hooks'
import _SignUpButton from "styles-SignUpButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sign_up_buttons/styles.js?styleId=SignUpButton";
import _SignupButtonLogo from "styles-SignupButtonLogo.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/sign_up_buttons/styles.js?styleId=SignupButtonLogo";


export const SignUpButton = /*#__PURE__*/styled(Button, null, {
  displayName: "SignUpButton",
  styles: _SignUpButton,
  attrs: props => ({
    ...props,
    decoration: 'ghost',
    size: 'small',
    isLargeScreen: useMedia({
      minWidth: 1260
    }, false)
  })
})
export const SignupButtonLogo = /*#__PURE__*/styled('img', null, {
  displayName: "SignupButtonLogo",
  styles: _SignupButtonLogo
})
